import { createSelector } from "reselect";

export const getChatMeta = (state) => state.chatMeta;

export const hasTyping = (chatId) =>
	createSelector(getChatMeta, (chatMeta) => chatMeta[chatId]?.typing);
